import gql from 'graphql-tag';

const exportPresentation = gql`
  query exportPresentation(
    $projectId: Int!
    $range: DateRangeInput!
    $criteriaKeys: [CriteriaKey!]
    $dataCollectorId: Int
    $thematics: [ThematicInput!]
    $keywords: [String!]
    $selectedEmotions: [Emotions!]
    $selectedClusters: [Cluster!]
    $noThematic: Boolean
    $templateId: Int!
    $thematicLevel: String!
    $thematicSelectionId: Int
  ) {
    exportPresentation(
      projectId: $projectId
      range: $range
      criteriaKeys: $criteriaKeys
      dataCollectorId: $dataCollectorId
      thematics: $thematics
      keywords: $keywords
      selectedEmotions: $selectedEmotions
      selectedClusters: $selectedClusters
      noThematic: $noThematic
      templateId: $templateId
      thematicLevel: $thematicLevel
      thematicSelectionId: $thematicSelectionId
    ) {
      code
      message
    }
  }
`;

export default exportPresentation;
